"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const cleaningBenefits = [];
export default function RealEstateCleaning() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: isFooterVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return;
}